import React from "react";

import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { GetApp } from "@mui/icons-material";
import Moment from "moment";

import { ButtonStyle0 } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const ExcelUsersListReportTransactions = ({
  excelData,
  fileName,
  disabled,
}) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const fileExtension = ".xlsx";
  let transformedData = [];

  const columnHeaders = {
    Empresa: "Empresa",
    Cliente: "Cliente",
    Documento: "Documento",
    Producto: "Producto",
    Caracteristica: "Características",
    Pago: "Pago",
    Sub_Total: "Sub total",
    Iva_Total: "IVA total",
    Pago_Total: "Pago total",
    Estado_pago: "Estado de pago",
    Iva_porcentaje: "IVA %",
    Registro: "Inicio de Vigencia",
    Terminos_aceptados: "Términos aceptados",
    Fecha_pago: "Fecha de pago",
    Operador: "Gestor",
    Comisión_operador: "Comisión gestor",
    tipo_pago: "Forma de pago",
    status: "Estado transacción",
  };

  // CREAR LA LISTA CON EL MAPEADO
  if (excelData.length > 0) {
    transformedData = excelData.map((item) => {
      const paidTransaction = item.paymentTransactions.find(
        (transaction) => transaction.status === 1
      );

      let caracteristicas = item.productsJson[0].prices.find(
        (data) => data.price === item.productsJson[0].priceSelect
      );

      const commissionPercentage = item.commissionPercentageUser
        ? parseFloat(item.commissionPercentageUser)
        : 0;
      const payTotal =
        item.productsJson[0].typePay === "CR"
          ? parseFloat(item.productsJson[0].payMonthTotal)
          : parseFloat(item.productsJson[0].payTotal);

      // Cálculo de la comisión
      const percentage =
        isNaN(commissionPercentage) || isNaN(payTotal)
          ? 0
          : (commissionPercentage * payTotal) / 100;

      // Creamos un objeto vacío para cada fila
      const row = {};

      // Validamos si existe `companyName`, si es así, lo añadimos al objeto `row`
      if (item.companyName) {
        row.Empresa = item.companyName;
      }

      // Ahora llenamos el resto de los campos en `row`
      row.Cliente = item.client.allNames;
      row.Documento = item.client.documentId;
      row.Producto =
        item.productsJson[0]?.productType === "hidden"
          ? item.productsJson[0].name
          : item.product.name;
      row.Caracteristica = caracteristicas.name;
      row.Pago =
        item.productsJson[0].typePay === "CR"
          ? "COBRO RECURRENTE"
          : item.productsJson[0].periodo;
      row.Sub_Total =
        item.productsJson[0].typePay === "CR"
          ? parseFloat(item.productsJson[0].subMonthTotal)
          : parseFloat(item.productsJson[0].subTotal);
      row.Iva_Total =
        item.productsJson[0].typePay === "CR"
          ? parseFloat(item.productsJson[0].ivaMonthTotal)
          : parseFloat(item.productsJson[0].ivaTotal);
      row.Pago_Total =
        item.productsJson[0].typePay === "CR"
          ? parseFloat(item.productsJson[0].payMonthTotal)
          : parseFloat(item.productsJson[0].payTotal);
      row.Estado_pago =
        paidTransaction || item.productsJson[0].typePay === "E"
          ? "PAGADO"
          : "POR PAGAR";
      row.Iva_porcentaje =
        parseFloat(item.productsJson[0].ivaTotal) === 0
          ? 0
          : item.productsJson[0].iva;
      row.Registro = Moment(item.createdAt).format("YYYY-MM-DD");
      row.Terminos_aceptados =
        item.acceptTerms ||
        item.productsJson[0].typePay === "E" ||
        item.productsJson[0].typePay === "CR"
          ? "SI"
          : "NO";
      row.Fecha_pago = paidTransaction
        ? Moment(paidTransaction.createdAt).format("YYYY-MM-DD")
        : item.productsJson[0].typePay === "E"
        ? Moment(item.createdAt).format("YYYY-MM-DD")
        : "";
      row.Operador = item.user.allNames;
      row.Comisión_operador = parseFloat(percentage.toFixed(2));
      row.tipo_pago =
        item.productsJson[0].typePay === "E"
          ? "EFECTIVO"
          : "TARJETA DE CREDITO";
      row.status = parseInt(item.status) === 0 ? "CANCELADO" : "ACTIVO";

      // Mapeamos los encabezados con los valores correspondientes
      const mappedRow = Object.keys(row).reduce((acc, key) => {
        acc[columnHeaders[key] || key] = row[key];
        return acc;
      }, {});

      return mappedRow;
    });
  }

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(transformedData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <>
      {/*<Tooltip title={fileName}>*/}
      <ButtonStyle0
        onClick={(e) => exportToExcel(fileName)}
        // className={className}
        startIcon={<GetApp style={{ fontSize: 14 }} />}
        disabled={disabled}
      >
        {" "}
        DESCARGAR
      </ButtonStyle0>
      {/*</Tooltip>*/}
    </>
  );
};

export default ExcelUsersListReportTransactions;
